
export const stripTrailingSlash = (pageURL: string) => {
    return pageURL.endsWith('/') ?
        pageURL.slice(0, -1) :
        pageURL;
};
